import { createRouter, createWebHistory } from "vue-router";
import Swal from "sweetalert2";

import Analytics from "../views/main/Analytics.vue";
import UserSearch from "../views/main/UserSearch.vue";
import AnalyticsByProvince from "../views/main/AnalyticsByProvince.vue";

import Padron from "../examples/CargarPadron.vue";

import VoterForm from "../views/mobile/VoterForm.vue";
import Verification from "../views/mobile/Verification.vue";
import Inicio from "../views/mobile/Main.vue";

import Login from "../views/auth/login.vue";
import RecoverPassword from "../views/auth/RecoverPassword.vue";
import ResetPassword from "../views/auth/ResetPassword.vue";

import UserIndex from "../views/Users/UserIndex.vue";
import NewUser from "../views/Users/NewUser.vue";
import UpdateUser from "../views/Users/UpdateUser.vue";
import UpdatePassword from "../views/Users/UpdatePassword.vue";
import Overview from "../views/profile/Overview.vue";
import LogsTable from "@/views/profile/LogsTable.vue";
import { getToken } from "../utilities/storage";
//si
const routes = [
  {
    path: "/",
    name: "/",
    redirect: "/analisis/pais"
  },
  {
    path: "/analisis/pais",
    name: "Análisis General",
    component: Analytics,
    meta: { requiresAuth: true, role: ["administrador", "dueno"] }  // Only admin and dueno can access
  },

  {
    path: "/analisis/elector",
    name: "Elector",
    component: UserSearch,
    //meta: { requiresAuth: true, role: ["administrador", "dueno"] }  // Only admin and dueno can access
  },

  {
    path: "/analisis/provincia/:province",
    name: "Análisis Provincia",
    component: AnalyticsByProvince,
    props: true,   
    meta: { requiresAuth: true, role: ["administrador", "dueno"] }  // Only admin and dueno can access
  },

  {
    path: "/padron",
    name: "Subir Padron",
    component: Padron,
    meta: { requiresAuth: true, role: ["administrador", "dueno"] }  // Only admin and dueno can access

  },

  {
    path: "/elector",
    name: "Formulario Elector",
    component: VoterForm,
    meta: { requiresAuth: true, role: ["administrador", "dueno", "usuario"] }  
    
  },

  {
    path: "/elector/verificacion",
    name: "Verificacion Elector",
    component: Verification,
  },

  {
    path: "/inicio",
    name: "Formulario",
    component: Inicio,
    meta: { requiresAuth: true }  // Only admin and dueno can access

  },

  
   //Auth
  {
    path: "/autenticacion/iniciar-sesion",
    name: "Login",
    component: Login,
    meta: {
      title: "Somos PLN - Elecciones 1 de Febrero 2026",
      metaTags: [
        {
          name: 'description',
          content: 'PLN - Partido Liberación Nacional, partido político de Costa Rica, elecciones febrero 2026. Inicia sesión para acceder a la plataforma de gestión electoral.'
        },
        {
          name: 'keywords',
          content: 'pln, somos, liberación, elecciones, febrero, 2026, partido, político, login, iniciar sesión'
        }
      ]
    }
  },
  {
    path: "/autenticacion/recuperar-contrasena", //Recover Pass (email)
    name: "Recover Password",
    component: RecoverPassword,
  },
  {
    path: "/autenticacion/reiniciar-contrasena/:token?", ///////////Reset PASS
    name: "Reset Password",
    component: ResetPassword,
  },

    //USUARIOS
    {
      path: "/usuarios/usuarios-organizacion",
      name: "Usuarios",
      component: UserIndex,
      //meta: { requiresAuth: true },
      meta: { requiresAuth: true, role: ["administrador", "dueno"] }  // Only admin and dueno can access

    },
    {
      path: "/usuarios/nuevo-usuario",
      name: "New User",
      component: NewUser,
      //meta: { requiresAuth: true },
      meta: { requiresAuth: true, role: ["administrador", "dueno"] }  // Only admin and dueno can access

    },
    {
      path: "/pages/users/update-user",
      name: "Update User",
      component: UpdateUser,
      //meta: { requiresAuth: true },
      meta: { requiresAuth: true, role: ["administrador", "dueno"] }  // Only admin and dueno can access

    },
    {
      path: "/pages/users/update-password",
      name: "Update Password",
      component: UpdatePassword,
      //meta: { requiresAuth: true },
      meta: { requiresAuth: true, role: ["administrador", "dueno"] }  // Only admin and dueno can access

    },
    {
      path: "/configuracion/mi-perfil",
      name: "Mi Perfil",
      component: Overview,
      meta: { requiresAuth: true },
    },
  
    {
      path: "/configuracion/logs",
      name: "Historial de Cargas",
      component: LogsTable,
      //meta: { requiresAuth: true },
      meta: { requiresAuth: true, role: ["administrador", "dueno"] }  // Only admin and dueno can access

    },
    {
      path: "/:pathMatch(.*)*",
      redirect: "/autenticacion/iniciar-sesion", // Redirect to login or an error page
      //meta: { requiresAuth: false }, 
    }
 
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  linkActiveClass: "active"
});

// META TAGS GUARD - This should be FIRST
router.beforeEach((to, from, next) => {
  // Set document title
  document.title = to.meta.title || 'Somos PLN - Elecciones 1 de Febrero 2026';
  
  // Remove any existing meta tags
  const existingMetaTags = document.querySelectorAll('meta[name="description"], meta[name="keywords"]');
  existingMetaTags.forEach(tag => tag.remove());
  
  // Add new meta tags
  if (to.meta.metaTags) {
    to.meta.metaTags.forEach(tag => {
      const meta = document.createElement('meta');
      meta.name = tag.name;
      meta.content = tag.content;
      document.head.appendChild(meta);
    });
  }
  
  // Continue to next guard
  next();
});

// Alerta de carga
router.beforeEach((to, from, next) => {
  const token = getToken();
  const userRole = sessionStorage.getItem("usuarioRol"); // Get the role from sessionStorage

  if (to.matched.some(record => record.meta.requiresAuth)) {
    // If route requires authentication but no valid token
    if (!token || token === "Bearer invalid") {
      console.log("Token invalido, redirigiendo a login...");
      localStorage.removeItem("token"); // Limpiar token inválido
      next({ name: "Login" });
    } else {
      // Check the user's role for access
      if (to.matched.some(record => record.meta.role && !record.meta.role.includes(userRole))) {
        console.log("No tienes permisos para acceder a esta página");
        // Redirect to a page with no access (or an error page)
        next({ name: "Formulario" });  // Or another route that a user with restricted access can see
      } else {
        next(); // Allow access to the route
      }
    }
  } else {
    next(); // Allow access to routes that do not require authentication
  }

  // Alerta de carga
  Swal.fire({
    title: "Cargando...",
    text: "Por favor, espera",
    allowOutsideClick: false,
    didOpen: () => {
      Swal.showLoading();
    },
  });

  // Delay para evitar error getContext de graficos
  setTimeout(() => {
    next();
  }, 800); 
});



router.afterEach(() => {
  setTimeout(() => {
    Swal.close();
  }, 500);
});

export default router;
